import React from 'react';
const IconFormDashSquareOutlined = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3 3V21H21V3H3ZM19 19H5V5H19V19Z" fill="#2D2E2E"/>
<path d="M17 11H7V13H17V11Z" fill="#2D2E2E"/>
</svg>
);
};
export default IconFormDashSquareOutlined;